import { MANUALLY_SEND_EMAIL, MANUALLY_SEND_EMAIL_INCREMENT } from '../Actions/actionName';

const ManuallySentEmailReducer = (state = {}, action) => {
  switch (action.type) {
    case MANUALLY_SEND_EMAIL:
      // legacy action now ignored (no change)
      return state;
    case MANUALLY_SEND_EMAIL_INCREMENT: {
      const prev = state[action.activityId] || 0;
      return {
        ...state,
        [action.activityId]: prev + 1,
      };
    }
    default:
      return state;
  }
};

export default ManuallySentEmailReducer;
